import { render, staticRenderFns } from "./SimplePayerRow.vue?vue&type=template&id=5d4f2338&scoped=true"
import script from "./SimplePayerRow.vue?vue&type=script&lang=js"
export * from "./SimplePayerRow.vue?vue&type=script&lang=js"
import style0 from "./SimplePayerRow.vue?vue&type=style&index=0&id=5d4f2338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f2338",
  null
  
)

export default component.exports